import { isNaN } from "lodash";

enum MacroMultipler {
  CARBS = 4,
  PROTEIN = 4,
  FATS = 9,
}

type CalculateMacro = {
  carbsPercentage: (grams: number) => number;
  proteinPercentage: (grams: number) => number;
  fatsPercentage: (grams: number) => number;
};

export const calculateMacro = (totalKcal: number): CalculateMacro => ({
  carbsPercentage: (grams: number) =>
    defaultToZero(
      Math.round(((grams * MacroMultipler.CARBS) / totalKcal) * 100)
    ),
  proteinPercentage: (grams: number) =>
    defaultToZero(
      Math.round(((grams * MacroMultipler.PROTEIN) / totalKcal) * 100)
    ),
  fatsPercentage: (grams: number) =>
    defaultToZero(
      Math.round(((grams * MacroMultipler.FATS) / totalKcal) * 100)
    ),
});

export const defaultToZero = (value: number): number =>
  isNaN(value) ? 0 : value;
